module.exports = __webpack_public_path__ + "static/media/maisight_screenshot.0b70d3f9.webp";